import queryString from 'query-string';
import httpStatus from 'http-status';

import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'
import { axsToken } from '../_helpers/auth-header'
import { store } from '../_helpers/store';

export const usersService = {
  getSetupToken,
  confirmAccount,
  setupAccount,
  getUser,
  addUser,
  updateUser,
  resendUser,
  getOptionsSpecialty,
  getOptionsLicensed,
  getOptionsStaff,
  retrieveUsers,
  reactivateUser,
  inactivateUser,
  changePassword,
  addTeamMembers,
  getTeamMembers,
  getLicensedTeam,
  getLocationTeam,
  updateUserImage,
  removeFromTeam,
  removeTeamMember,
  addToLicensedTeam,
  addToLocationTeam,
  toggleNotifications,
  removeFromLocationTeam,
};

function removeFromTeam (staffId, licensedId) {
  return axiosInstance.request({
    method: 'DELETE',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/licensed-teams`,
    data: { staffId, licensedId }
  })
}

function getSetupToken(token) {
  return axiosInstance.request({
    method: 'GET',
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${token}/setup`
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data.data
    }
  })
}

function confirmAccount(token) {
  return axiosInstance.request({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${token}/setup`,
  }).then(response => {
    if (response && response.status === httpStatus.CREATED) {
      return response.data.data
    }
  })
}

function setupAccount(token, password) {
  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${token}/setup`,
    data: { password }
  }).then(response => {
    if (response && response.status === httpStatus.CREATED) {
      return response.data.data
    }
  })
}

function getUser(id) {
  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${id}`,
  })
  .then(response => {
    if (response && response.status === httpStatus.OK) {
      return response.data.data
    }
  })
}

function getOptionsStaff(page = 1, search = false) {
  const clientId = store.getState().client.id;

  let url  = `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/options-staff?providerId=${clientId}&page=${page}`

  if (search) {
    url += `&search=${search}`
  }

  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: url
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data
    }
  })
}

function getOptionsLicensed(page = 1, search = false) {
  const clientId = store.getState().client.id;

  let url  = `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/options-licensed?providerId=${clientId}&page=${page}`

  if (search) {
    url += `&search=${search}`
  }

  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: url
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data
    }
  })
}


function getOptionsSpecialty() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/options-specialty?providerId=${clientId}`
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data.data
    }
  })
}

function addUser(data) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users`,
    data: {
      ...data,
      providerId: clientId
    }
  }).then((response) => {
    if (response && response.status === httpStatus.CREATED) {
      return response.data.data
    }
  })
}

function updateUser(id, data) {
  return axiosInstance.request({
    method: 'PATCH',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${id}`,
    data: { ...data }
  }).then((response) => {
    return response.data;
  })
}

function resendUser(id) {
  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${id}/resend-email`
  });
}

function updateUserImage(base64Image) {
  // return axiosInstance.request({
  //   method: 'POST',
  //   headers: authHeader(),
  //   url: `${process.env.REACT_APP_API_URL}/${getApiVersion()}/client/profile/image`,
  //   data: { image: base64Image }
  // }).then((response) => {
  //   return response.data;
  // })
}

function retrieveUsers(params = {}) {
  const clientId = store.getState().client.id;

  params.providerId = clientId

  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users?${queryString.stringify(params)}`
  }).then((response) => {      
    if (response && response.status === httpStatus.OK) {
      return response.data;
    }
  })
}

function getLocationTeam() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const collection = {
        data: [
          {
            name: 'Lugonia Murrieta',
            type: 'Lugonia Orthopedic',
            count: 4,
            profileUrl: 'https://image.shutterstock.com/image-photo/modern-hospital-style-building-260nw-212251981.jpg',
            address: '9124 Scott Rd., Suite 9B Murrieta, CA 91838'
          },
          {
            name: 'Beaumont Office',
            type: 'Lugonia Orthopedic',
            count: 2,
            profileUrl: 'https://media.istockphoto.com/photos/modern-hospital-building-picture-id1312706413?b=1&k=20&m=1312706413&s=170667a&w=0&h=VRi3w2E1UqvCCcK-nDV6mH7FhDZoTU9MM2QKSom96X4=',
            address: '9182 Beaumont Ave, Suite 304 Beaumont, CA 92193'
          },
          {
            name: 'Redlands Spine Center',
            type: 'Lugonia Orthopedic',
            count: 0,
            profileUrl: 'https://media.gettyimages.com/photos/study-of-architectural-form-05-picture-id173799627?s=612x612',
            address: '1901 Lugonia Ave Redlands, CA 92324'
          },
        ]
      }
      // reject('fail')
      resolve(collection);
    }, 500);
  });
}

function reactivateUser(userId) {
  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${userId}/activate`,
  })
}

function inactivateUser(userId) {
  return axiosInstance.request({
    method: 'DELETE',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${userId}`,
  })
}

function changePassword(userId, password) {
  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${userId}/password`,
    data: { password }
  });
}

function getTeamMembers(licensedId) {
  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/licensed/${licensedId}/team-members`,
  });
}

function addTeamMembers(licensedId, teamMembers) {
  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/team-members`,
    data: { licensedId, teamMembers }
  });
}

function removeTeamMember(licensedId, staffId) {
  return axiosInstance.request({
    method: 'DELETE',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/team-members`,
    data: { staffId, licensedId }
  })
}

function getLicensedTeam(staffId) {
  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/users/${staffId}/licensed-teams`,
  });
}

function addToLicensedTeam(user, licensedTeams) {
  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/licensed-teams`,
    data: { staffId: user.userId, licensedTeams }
  });
}

function addToLocationTeam() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // reject('fail')
      resolve('Add to loc Team');
    }, 500);
  });
  // return axiosInstance.request({
  //   method: 'POST',
  //   headers: authHeader(),
  //   url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/change-password`,
  //   data: { currentPassword, password, confirmPassword }
  // });
}

function removeFromLocationTeam() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // reject('fail')
      resolve('remove from loc Team');
    }, 500);
  });
}

function toggleNotifications(licensedId, status) {
  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/licensed/${licensedId}/message-notifications`,
    data: { status }
  }).then(response => {
    if (response && response.status === httpStatus.CREATED) {
      return response.data.status
    }
  })
}